const $ = require('jquery');

class HeaderSkipLinksController {
    constructor($timeout, moveFocus, shopperService, shopPageStateService, loginService) {
        this.$timeout = $timeout;
        this.moveFocus = moveFocus;
        this.shopperService = shopperService;
        this.shopPageStateService = shopPageStateService;
        this.loginService = loginService;

        this.a11yOptionsOpen = false;
    }

    $postLink() {
        // auto hide focus is outside of the panel
        $('._a11yOptions').off('focusout.a11yOptions').on('focusout.a11yOptions', () => {
            // Timeout here because no item has focus yet, the check will now happen after focusin event has fired.
            this.$timeout(() => {
                // toggle if focus goes outside of small menu container
                if ($(document.activeElement).closest('._a11yOptions').length === 0) {
                    this.a11yOptionsOpen = false;
                }
            }, 0);
        });
    }

    $onDestroy() {
        $('._a11yOptions').off('focusout.a11yOptions');
    }

    openA11yOptions() {
        this.a11yOptionsOpen = true;
    }

    updatePreference() {
        this.shopperService.setPreferenceEnableAccessibility(this.shopperService.preferences.EnableAccessibleOptions);
    }

    goToTrolley() {
        this.shopPageStateService.isCartOpen = true;
        this.moveFocus('#right-panel');
    }

    goToNavigation() {
        this.moveFocus('#left-panel');
    }
}

const headerSkipLinksComponentDefinition = {
    controller: ['$timeout', 'MoveFocus', 'ShopperService', 'ShopPageStateService', 'LoginService', HeaderSkipLinksController],
    template: require('./header-skip-links.component.html').trim(),
};

module.exports = {
    HeaderSkipLinksController,
    headerSkipLinksComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/header-skip-links.component.js